import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    FormControl,
    FormGroup,
    Validators,
    FormBuilder,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from 'src/app/services/order/order.service';
import { DatePipe } from '@angular/common';
import { SettingService } from 'src/app/services/setting/setting.service';


@Component({
    selector: 'app-add-patient',
    templateUrl: './add-patient.component.html',
    styleUrls: ['./add-patient.component.scss']
  })
  export class AddPatientComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    // Props
    public title: string;
    public type: string;
    public data: any;
    public pages: any;
    public editId: any

    // Loader
    public isBtnLoaded = false;
    public PatientTouchSubmit = false;

    // From Group
    public patientForm: FormGroup;

    // Dropdown List
    public statelistForDropdown = [];
    public citylistForDropdownByState = [];
    public areacodelistForDropdown = [];

    public uploadPincodeInput = 'No'
    public fileName: any;
    public file: any;
    public fileerrmsg: boolean;
    public dateInputFormat: any;
    public today:any;
    constructor(
        private ngbModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private orderService: OrderService,
        private settingService: SettingService,
        private toastr: ToastrService,
        public datepipe: DatePipe,
    ) {
        this.today = new Date();
     }

    ngOnInit(): void {
        this.dateInputFormat = 'MM-DD-YYYY';
        this.patientForm = this.formBuilder.group({

            uhid: ['', Validators.required,],
            first_name: ['', Validators.required,],
            last_name: ['', Validators.required,],
            date_of_birth: ['', Validators.required,],
            phone: ['', Validators.required,],
            gender: ['', Validators.required,],
            user_id:[''],
            id:[''],
        });

        this.setDialogProps(this.props);
    }


    get patientInfo() {
        return this.patientForm.controls;
    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.pages = dialogdata.page;
        if (['edit'].includes(this.type)) {
            this.editId = this.data.id;
            this.patientForm.patchValue({id:this.data.data.patient_id});

            const newData = {
                ...this.data.data,
                gender: this.data.data.gender.toLowerCase(),
                date_of_birth: new Date(this.data.data.date_of_birth),
            }
            this.patientForm.patchValue(newData);
            // this.patientForm.patchValue(this.data.data);
            console.log(newData);

        }

    }

    closeModal() {
        this.passEntry.next(this.pages);
        this.ngbModal.close();
    }

    create() {
       this.PatientTouchSubmit = true
        if (this.patientForm.valid) {
            this.isBtnLoaded = true;
            this.patientForm.patchValue({user_id:this.data});
            //
            this.orderService.createPatient(this.patientForm.value).subscribe((res: any) => {
                if (res.success) {
                    this.toastr.success(`${res.message}`);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(`Added Successfully`);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                this.closeModal();
                this.isBtnLoaded = false;
            })
        }

        else {
            this.patientForm.markAllAsTouched();
        }
    }



    update() {
        this.PatientTouchSubmit = true
         if (this.patientForm.valid) {
             this.isBtnLoaded = true;
             this.patientForm.patchValue({user_id:this.data.id});
            //  this.patientForm.patchValue({date_of_birth: new Date(this.patientForm.get('date_of_birth')?.value)});
             this.patientForm.patchValue({date_of_birth: this.datepipe.transform(this.patientForm.value.date_of_birth, 'YYYY-MM-dd HH:MM:ss')});
              this.orderService.editPatient(this.patientForm.value).subscribe((res: any) => {
                 if (res.success) {
                     this.toastr.success(`${res.message}`);
                 } else {
                     if (res.message) {
                         this.toastr.error(`${res.message}`);
                     } else {
                         this.toastr.error(`Added Successfully`);
                     }
                 }
             },
             (err: any) => {
                 this.toastr.error(`${err}`);
             },
             () => {
                 this.closeModal();
                 this.isBtnLoaded = false;
             })
         }

         else {
             this.patientForm.markAllAsTouched();
         }
     }
}

